<div class="rubro-detail" *ngIf="inmo || agro || arq || insti">

  <!-- Background elements -->
  <div class="rd-grid"></div>
  <div class="rd-glow"></div>

  <!-- Header -->
  <div class="rd-header">

    <div class="rd-breadcrumb">
      <span (click)="router.navigate(['/'])">{{ t.home }}</span>
      <span class="sep">→</span>
      <span (click)="router.navigate(['/servicio/desarrollo-web'])">{{ t.services }}</span>
      <span class="sep">→</span>
      <span class="current">{{ getCurrentTitle() }}</span>
    </div>

    <div class="rd-header-inner">
      <div class="rd-header-left">
        <div class="rd-label">{{ t.label }}</div>
        <h1 class="rd-title">{{ getCurrentTitle() }}</h1>
        <p class="rd-subtitle">{{ getCurrentSubtitle() }}</p>
      </div>
      <div class="rd-header-img">
        <img [src]="getCurrentImage()" [alt]="getCurrentTitle()" />
      </div>
    </div>

    <div class="rd-line-animated">
      <div class="rd-star"></div>
    </div>

  </div>

  <!-- Intro -->
  <div class="rd-intro">
    <p class="rd-intro-text" [innerHTML]="getCurrentIntro()"></p>
  </div>

  <!-- Features -->
  <div class="rd-features">
    <div class="rd-features-label">{{ t.features_label }}</div>
    <div class="rd-feature-item" *ngFor="let f of getCurrentFeatures(); let i = index">
      <div class="rd-feature-num">0{{ i + 1 }}</div>
      <div class="rd-feature-content">
        <h3 class="rd-feature-title">{{ f.title }}</h3>
        <p class="rd-feature-desc">{{ f.desc }}</p>
      </div>
      <div class="rd-feature-divider"></div>
    </div>
  </div>

  <!-- Closing text + CTA -->
  <div class="rd-closing">
    <div class="rd-closing-text">
      <p [innerHTML]="getClosingText()"></p>
    </div>
  </div>

  <div class="rd-cta">
    <div class="rd-cta-inner">
      <div class="rd-cta-text">
        <div class="rd-cta-label">{{ t.cta_label }}</div>
        <h2 class="rd-cta-title" [innerHTML]="t.cta_title"></h2>
      </div>
      <div class="rd-cta-actions">
        <a href="https://wa.me/543416902287" target="_blank" class="btn-primary">{{ t.cta_whatsapp }} →</a>
        <a href="mailto:hola@patagonia-chain.com" class="btn-secondary">{{ t.cta_email }}</a>
      </div>
    </div>
  </div>

</div>
